<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title"><span class="atbold">Table of Contents</span></h2>
<p class="toc"><a href="#/xhtml/fm03">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/fm05">Foreword</a></p>
<p class="toc"><span href="#/xhtml/fm06" title="Link target outside of Sample">Introduction by Ed Goeas</span></p>
<p class="toc-part"><span href="#/xhtml/part01" title="Link target outside of Sample"><span class="tbold">Part One | The Great Divide</span></span></p>
<p class="toc-chap"><span href="#/xhtml/chap01" title="Link target outside of Sample"><span class="tno">Chapter 1.</span> Vanishing Respect: The Loss of Trust in an Uncivil Society</span></p>
<p class="toc-chap"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="tno">Chapter 2.</span> Cynicism: Many Americans Doubt There <span class="titalic">Are</span> Solutions</span></p>
<p class="toc-chap"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="tno">Chapter 3.</span> Polarization: A Deep Dive into the Great Divide</span></p>
<p class="toc-chap"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="tno">Chapter 4.</span> Toxic Incentives: Bad Behavior Richly Rewarded</span></p>
<p class="toc-part"><span href="#/xhtml/part02" title="Link target outside of Sample"><span class="tbold">Part Two | Building Bridges</span></span></p>
<p class="toc-chap"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="tno">Chapter 5.</span> Problem-Solving Strategies: Workable Solutions for a New Era</span></p>
<p class="toc-chap"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="tno">Chapter 6.</span> Not So Social Media: Repairing a Once Promising Connectivity</span></p>
<p class="toc-chap"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="tno">Chapter 7.</span> Cable News Networks: Dousing the Flames of Discord</span></p>
<p class="toc-chap"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="tno">Chapter 8.</span> Reforms: Tackling Campaign Finance and Special Interest Privilege</span></p>
<p class="toc-chap"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="tno">Chapter 9.</span> COVID-19: A Perfect Example of Extreme Polarization</span></p>
<p class="toc-chap"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="tno">Chapter 10.</span> Looking Toward a Respectful Future</span></p>
<p class="toct"><span href="#/xhtml/bm01" title="Link target outside of Sample">Our Final Note</span></p>
<p class="toc"><span href="#/xhtml/bm02" title="Link target outside of Sample">About the Authors</span></p>
<p class="toc"><span href="#/xhtml/bm03" title="Link target outside of Sample">Appendices</span></p>
<p class="toc"><span href="#/xhtml/bm04" title="Link target outside of Sample">Endnotes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?3385d36d